<div class="tlr-editor-container">
    <h3 class="header_repair">TLR Editor change Repaired TLR to Installed
</h3>
    <div class="search-row">
        <div class="label">Enter Tag Number</div>
        <input type="text" id="tagNumber" (keydown.enter)="searchTag()" [(ngModel)]="tagNumber">
        <button pButton class="primary-btn" (click)="searchTag()">Search Tag</button>
    </div>
    
    <div class="status-message" *ngIf="statusMessage">
        {{statusMessage}}
    </div>

    <div *ngIf="isDataLoaded" class="data-container">
        <div class="data-tables">
            <!-- Operations Table -->
            <p-table id="StyleTable" [value]="operationsTableData" class="operations-table custom-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th colspan="2" class="header-row">Operations</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td class="label">{{item.key}}</td>
                        <td class="value" [ngClass]="{'green': item.key === 'TLR Status' && item.cssClass === 'green', 'red': item.key === 'TLR Status' && item.cssClass === 'red', 'blue': item.key === 'TLR Status' && item.cssClass === 'blue'}">{{item.value}}</td>
                    </tr>
                </ng-template>
            </p-table>

            <!-- Inspections Table -->
            <p-table id="StyleTable" [value]="inspectionsTableData" class="inspections-table custom-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th colspan="2" class="header-row">Inspections</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td class="label">{{item.key}}</td>
                        <td class="value">{{item.value}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="button-container">
            <button pButton 
                    class="primary-btn update-status-btn" 
                    *ngIf="rawTlrStatusCode === 'R' || rawTlrStatusCode === 'Removed'" 
                    (click)="updateStatusToInstalled()">
                Update Status as Removed -- Installed
            </button>
        </div>
    </div>
    
</div>
